module.exports = __webpack_public_path__ + "static/media/habla.a38dd508.png";